module.exports = __webpack_public_path__ + "static/media/items.c8f73353.png";